﻿var scroller = (function ($) {
    "use strict";
    var module = {};
    var speed = 600;

    module.scrollToElem = function ($elem, offset) {
        if (!$elem) { return false; }
        var elemPos = $elem.offset().top;
        module.scrollToPosition(elemPos, null, offset);
    };

    module.scrollToPosition = function (pos, hash, offset) {
        if (typeof offset === "undefined") { offset = 0; }

        $('html, body').animate({
            scrollTop: (pos + offset)
        }, speed, function () {
            if (typeof hash !== undefined && hash !== null) {
                window.location.hash = hash;
            }
        });
    };

    module.init = function () {
        var $scroll = $('html, body'),
        $body = $scroll.filter('body');

        $body.on('click.internal', '[href*="#"]', function (event) {
            var $a = $(event.target).closest('a'),
            href = $a.attr('href'),
            hash,
            $target;

            if (href.length) {
                hash = href.substring(href.indexOf('#'));
                $target = $(hash);
            }

            if ($target.length) {
                event.preventDefault();
                module.scrollToPosition($target.offset().top, hash);
            }
        });
    };

    $(document).ready(function () {
         //module.init();
    });

    return module;
})(jQuery);

module.exports = scroller;